import React from 'react';
import { MapPinIcon, PhoneIcon, TruckIcon } from 'lucide-react';
import { ContactForm } from './ContactForm';
const nextSteps = [{
  title: 'Qualification sous 48 h',
  text: 'Un chargé d’affaires valide la faisabilité et les premières contraintes.'
}, {
  title: 'Étude & modélisation 3D',
  text: 'Le bureau d’études découpe le volume en modules fabricables et transportables.'
}, {
  title: 'Devis & planning',
  text: 'Chiffrage détaillé par pôle, rétroplanning jusqu’à la livraison.'
}];
export function ContactSection() {
  return <section id="contact" aria-labelledby="contact-title" className="scroll-mt-[72px] bg-paper py-24 md:py-32" data-id="element-100" data-mp="2d9w54jc9bkwx">
      <div className="shell grid gap-14 lg:grid-cols-12" data-id="element-101" data-mp="2r5zqro92ekxs">
        <div className="lg:col-span-5" data-id="element-102" data-mp="2n5fv6p453pdr">
          <p className="inline-flex bg-line px-3 py-1.5 text-sm" data-id="element-103" data-mp="2n8lned82f7dp">Qualification rapide</p>
          <h2 id="contact-title" className="mt-6 text-[clamp(36px,4.6vw,64px)] font-medium leading-[0.98] tracking-[-0.04em]" data-id="element-104" data-mp="6g22jtbg6byn">
            Un projet de décor ou de volume ?
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-mute" data-id="element-105" data-mp="1j4pp1ok4sf9m">
            Décrivez-le en deux minutes, joignez vos plans : notre bureau d’études s’en saisit directement.
          </p>

          <ol className="mt-12 space-y-0" data-id="element-106" data-mp="1s18f8t0z9p2i">
            {nextSteps.map((step, i) => <li key={step.title} className="relative flex gap-5 pb-8 last:pb-0" data-id="element-107" data-mp="1x01q0dovr1yz" data-mpi={i}>
                {i < nextSteps.length - 1 && <span className="absolute left-[11px] top-7 h-[calc(100%-28px)] w-px bg-line" aria-hidden data-id="element-108" data-mp="14cywjzz29hfl" />}
                <span className="flex h-6 w-6 shrink-0 items-center justify-center bg-ink font-mono text-[11px] text-white" data-id="element-109" data-mp="19bigxvy0al5u">
                  {i + 1}
                </span>
                <div data-id="element-110" data-mp="gofnvjc3n2mz">
                  <p className="font-medium" data-id="element-111" data-mp="gmuw21h65xst">{step.title}</p>
                  <p className="mt-1 text-sm leading-relaxed text-mute" data-id="element-112" data-mp="lmz89fb1o6d8">{step.text}</p>
                </div>
              </li>)}
          </ol>

          <div className="mt-12 space-y-4 border-t border-line pt-8 text-[15px]" data-id="element-113" data-mp="1owbug4dbbhii">
            <p className="flex gap-3" data-id="element-114" data-mp="1jxqp5qj7e7n7">
              <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden data-id="element-115" data-mp="1jwz7ljmfyafx" />
              <a href="tel:+33476000000" className="font-medium hover:text-ember-dark" data-id="element-116" data-mp="1xpf0vspjiu3n">
                +33 4 76 00 00 00
              </a>
            </p>
            <p className="flex gap-3" data-id="element-117" data-mp="15y8z77u68oc9">
              <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden data-id="element-118" data-mp="15zaks68tct88" />
              <span data-id="element-119" data-mp="111iiciajlops">12 rue des Forges, ZI Nord — 38320 Eybens</span>
            </p>
            <p className="flex gap-3 text-mute" data-id="element-120" data-mp="1f0rwzdj3oarn">
              <TruckIcon className="mt-0.5 h-4 w-4 shrink-0 text-ember" aria-hidden data-id="element-121" data-mp="1exckmigt9ftx" />
              <span data-id="element-122" data-mp="1a2qil5wmczmi">Quai poids lourds, semi-remorques sur rendez-vous</span>
            </p>
          </div>
        </div>

        <div className="lg:col-span-7" data-id="element-123" data-mp="2lfswft7c3b2z">
          <ContactForm data-id="element-124" data-mp="2lerc0y4fhc8l" />
        </div>
      </div>
    </section>;
}